import { render, staticRenderFns } from "./AllTickets.vue?vue&type=template&id=90953c74&scoped=true&"
import script from "./AllTickets.vue?vue&type=script&lang=js&"
export * from "./AllTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90953c74",
  null
  
)

export default component.exports